import axios from "axios";
import qs from "qs";
import store from '@/store'
import router from "@/router"

axios.defaults.baseURL = '/api'
// axios.defaults.baseURL = 'https://spapi.scssyn.com'

//post请求头
axios.defaults.headers.post["Content-Type"] = "application/json";

//设置超时
axios.defaults.timeout = 15000;

axios.interceptors.request.use(
    config => {
        config.headers.token = store.getters.getData('vuex_token') ? store.getters.getData('vuex_token') : ''
        config.headers.tenantId = store.getters.getData('vuex_tenantId') ? store.getters.getData('vuex_tenantId') : ''
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
    response => {
        if (response.status === 200) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    error => {
        if (error.response.status === 401){
            router.push('/login')
        }
    }
);
export default {
    /**
     * @param {String} url
     * @param {Object} data
     * @returns Promise
     */
    post(url, data) {
        return new Promise((resolve, reject) => {
            axios({
                method: 'post',
                url,
                data: data ? data : {},
            })
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => {
                    reject(err)
                });
        })
    },

    get(url, data) {
        return new Promise((resolve, reject) => {
            axios({
                method: 'get',
                url,
                params: data ? data : {},
            })
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => {
                    reject(err)
                })
        })

    },
    postBaseUrl(baseUrl, url, data) {
        return new Promise((resolve, reject) => {
            axios({
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                baseURL: baseUrl,
                method: 'post',
                url,
                params: data ? data : {},
            })
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => {
                    reject(err)
                });
        })
    },

    getBaseUrl(baseUrl, url, data) {
        return new Promise((resolve, reject) => {
            axios({
                baseURL: baseUrl,
                method: 'get',
                url,
                params: data ? data : {},
            })
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => {
                    reject(err)
                })
        })

    },
};
